import z from "./index.es476.js";
import E from "./index.es475.js";
import G from "./index.es477.js";
import R from "./index.es478.js";
function p(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = X(e)) || t) {
    r && (e = r);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X(e, t) {
  if (e) {
    if (typeof e == "string") return v(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e, t) : void 0;
  }
}
function v(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = Array(t); r < t; r++) o[r] = e[r];
  return o;
}
function q(e) {
  var t = e.data, r = e.sheetName, o = e.sheetNames, s = e.schema, n = e.columns, a = e.images, m = e.headerStyle, u = e.getHeaderStyle, f = e.fontFamily, c = e.fontSize, b = e.orientation, w = e.stickyRowsCount, A = e.stickyColumnsCount, C = e.showGridLines, F = e.rightToLeft, I = e.dateFormat, h = G(), k = h.getSharedStrings, L = h.getSharedString, y = E({
    fontFamily: f,
    fontSize: c
  }), $ = y.getStyles, T = y.getStyle;
  if (o && n && !Array.isArray(n[0]))
    throw new Error('In a "write multiple sheets" scenario, `columns` parameter must be an array of `columns` for each sheet.');
  o || (o = [r || "Sheet1"], t = [t], n && (n = [n]), s && (s = [s]), a && (a = [a])), m && !u && (u = function() {
    return m;
  });
  for (var H = p(o), d; !(d = H()).done; ) {
    var N = d.value;
    R(N);
  }
  for (var S = [], i = 0, j = p(o), g; !(g = j()).done; )
    g.value, S.push(z(t[i], {
      schema: s && s[i],
      columns: n && n[i],
      images: a && a[i],
      getHeaderStyle: u,
      getStyle: T,
      getSharedString: L,
      customFont: f || c,
      dateFormat: I,
      orientation: b,
      stickyRowsCount: w,
      stickyColumnsCount: A,
      showGridLines: C,
      rightToLeft: F,
      sheetId: i + 1
    })), i++;
  return {
    sheets: o.map(function(x, l) {
      return {
        id: l + 1,
        name: x,
        data: S[l],
        images: a && a[l]
      };
    }),
    getSharedStrings: k,
    getStyles: $
  };
}
export {
  q as generateSheets
};
//# sourceMappingURL=index.es434.js.map
